import * as Yup from "yup";

import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
// import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
// import { City, State, Country } from "country-state-city";

import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Select from "react-select";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import { postUserEntry } from "../../Service/AllUserEntryAPI";
import { validateUserName, validateEmail, validateMobileNo } from "./AllValidation";
import swal from "sweetalert";


const allowedDomains = [
  "gmail.com",
  "petrotec.com",
  "yahoo.in",
];


// ----- validate Phone No
const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$";
/* ----- declaration of validationSchema validation (based on the object schema provided by Yup) and display
  of validation errors ----- */
const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("Required *")
    .min(2, "Too Short!"),
  lastName: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
    .min(2, "Too Short!"),
  companyName: Yup.string().required("Required *"),
  userName: Yup.string().required("Required *")
    .min(2, "Too Short!"),
  mobileNo: Yup.string()
    .required("Required *")
    .matches(/^[0-9\s]+$/, "Enter Numbers Only")
    .test("valid-phone", "Invalid Mobile number", (value) => {
      if (!value) return false;
      const cleanedNumber = value.replace(/\s/g, "");
      return /^\d{10}$/.test(cleanedNumber);
    })
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
    .matches(phoneRegEx, "Mobile number is not valid"),
  pincode: Yup.string()
    .required("Required *")
    .matches(/^[0-9]{6}$/, "Pincode must be 6 digits"),

  password: Yup.string()
    .required("Required *")
    .min(8, "Password must be 8 characters long")
    .matches(/[0-9]/, "Must contain at least 1 digit (0-9)")
    .matches(/[a-z]/, "Must contain at least 1 lowercase letter (a-z)")
    .matches(/[A-Z]/, "Must contain at least 1 uppercase letter (A-Z)")
    .matches(/[^\w]/, "Must contain at least 1 symbol"),
  // email: Yup.string()
  //   .required("Required *")
  //   .email("Invalid email")
  //   // .test(
  //   //   "is-valid-domain",
  //   //   "Email address must be from the domain petrotec.com or petrotecindia.com",
  //   //   (value) => {
  //   //     const domain = value?.split("@")[1];
  //   //     return domain === "petrotec.com" || domain === "petrotecindia.com";
  //   //   }
  //   // )
  //   .test("com", "Email must include .com", (value) => {
  //     if (value && !value.includes(".com")) {
  //       return false;
  //     }
  //     return true;
  //   }),

  email: Yup.string()
    .required("Required *")
    .email("Invalid email"),
  // city: Yup.string().required("Required *")
  //   .matches(/^[A-Za-z\s]+$/, "City must only contain alphabets "),
  address: Yup.string().required("Required *"),
  designation: Yup.string().required("Select Category *"),
  desc: Yup.string()
    .required("Required *")
    .min(4, "It should have minimum 4 characters!")
    .max(225, "It should have maximum 225 characters!"),
});

export default () => {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("")
  const [cityOptions, setCityOptions] = useState([]);
  const [loadingPin, setLoadingPin] = useState(false);
  const [pincode, setPincode] = useState("");




  const [showJob, setShowJob] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  const [eyePass, setEyePass] = useState(false);
  const [userProfile, SetuserProfile] = useState('');
  const [uploadedImage, setUploadedImage] = useState(null);
  const [base64Image, setBase64Image] = useState("");
  const changeHandler = (e) => {
    if (e.value === "back office") {
      setShowJob(true);
    } else {
      setShowJob(false);
    }
  };

  const eyeTogglePass = () => {
    setEyePass(!eyePass);
  };

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);




  const fetchAddressByPincode = async (pin, formik) => {
    if (pin.length !== 6) return;

    setLoadingPin(true);

    try {
      const res = await fetch(
        `https://api.postalpincode.in/pincode/${pin}`
      );
      const data = await res.json();

      if (data[0].Status === "Success") {
        const postOffices = data[0].PostOffice;

        setCountry("India");
        setState(postOffices[0].State);
        setDistrict(postOffices[0].District);

        const cities = postOffices.map(po => ({
          label: po.Name,
          value: po.Name
        }));

        setCityOptions(cities);

        // optional auto select first city
        formik.setFieldValue("city", cities[0]?.value || "");
      } else {

        setState("");
        setCityOptions([]);
        formik.setFieldValue("city", "");

        swal("Invalid PIN", "No data found for this pincode", "warning");
      }
    } catch (err) {
      console.error(err);
      swal("Error", "Failed to fetch pincode data", "error");
    } finally {
      setLoadingPin(false);
    }
  };





  const userDesignationList = [
    { value: "back office", label: "Back Office" },
    { value: "wo creattion user", label: "Work order Creattion User" },
    { value: "production reading ", label: "Production Reading " },
    { value: "dispatch User", label: "Dispatch User" },
    { value: "service engineer", label: "Service Engineer" },
    { value: "customer", label: "Customer" },
    { value: "dealer", label: "Dealer" },
    { value: "nontech person", label: "Non Tech person" },
    { value: "tech person", label: "Tech Person" },
    { value: "ro_manager", label: "Ro Manager" },
    { value: "Sales_person", label: "Sales Person" },
    { value: 'RND_REVIEWER', label: 'RND Reviewer' },
    { value: 'PROCUREMENT_REVIEWER', label: 'Procurement Reviewer' },
    { value: 'FINANCE_REVIEWER', label: 'Finance Reviewer' },
    { value: 'SLT_REVIEWER', label: 'SLT Reviewer' },
    { value: 'PRODUCTION_REVIEWER', label: 'Production Reviewer' },
    {value :'Employee', label:'Employee'},
    {value :'Manager', label:'Manager'},
 
  ];




  const departmentList = [
    { value: "Ro department", label: "Ro Department" },
    { value: "mechanical", label: "Mechanical" },
    { value: "hardware", label: "Hardware" },
    { value: "software", label: "Software" },
    { value: "electronic", label: "Electronic" },
    { value: "firmware", label: "Firmware" },
    { value: "IT department", label: "IT Department" },
    { value: "Sales department", label: " Sales department" },
    { value: "RND department", label: "RND Department" },
    { value: "Procurement department", label: "Procurement Department" },
    { value: "Finance department", label: "Finance Department" },
    { value: "SLT Department", label: "SLT Department" },
    { value: "Production department", label: "Production Department" },


  ];

  const validateCompanyName = (value) => {
    if (/^\d+$/.test(value)) {
      return "Company Name must contain at least one non-numeric character";
    }
    return undefined;
  };

  const jobList = [
    { value: "productionReading", label: "Production Reading" },
    { value: "dispatchOrder", label: "Dispatch Order" },
    { value: "fieldWorkOrderCreation", label: "Field Work Order Creation" },
    { value: "fieldServiceEngineer", label: "Field Service Engineer" },
  ];

  const uploadImg = (e) => {
    console.log("uploadImg :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("file :-", file);

    if (file) {
      // Check if the file is an image
      if (!file.type.startsWith('image/')) {
        // If the file is not an image, set the error message
        SetuserProfile("Please upload an image file.");
        // setButtonDisabled(true);
        return;
      }

      // Check if the image size exceeds 100 KB
      if (file.size > 100 * 1024) { // 100 KB in bytes
        // If the image size exceeds 100 KB, set the error message
        SetuserProfile(
          <p>
            The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
            <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank">
              <span style={{ color: 'blue', textDecoration: 'none' }}>https://image.pi7.org/reduce-image-size-in-kb</span>
            </a>.
          </p>
        );
        // setButtonDisabled(true);
        return;
      }

      // If the file is an image and size is within limits, proceed with reading it
      const reader = new FileReader();
      reader.onload = () => {
        setBase64Image(reader.result);
        // setButtonDisabled(false);
      };
      reader.readAsDataURL(file);
      setUploadedImage(file);
    }
  };



  return (
    <Formik
      // ----- declaration of initialValues
      initialValues={{
        firstName: "",
        lastName: "",
        companyName: "",
        mobileNo: "",
        userName: "",
        password: "",
        address: "",
        email: "",
        country: "",
        state: "",
        district: "",
        city: "",
        pincode: "",
        role: "",
        desc: "",
        userProfile: "",
        deparment: "",
      }}
      // ----- Function call to validationSchema
      validationSchema={validationSchema}
      // ----- declaration of onSubmit callback
      onSubmit={async (values, { resetForm }) => {
        setisLoaded(true);
        try {
          // ----- code that we will 'try' to run
          const loginUserName = sessionStorage.getItem("userName");
          // ----- Object to add User data
          // const data = {
          //   firstName: values.firstName
          //     .toLowerCase()
          //     .split(" ")
          //     .map((word) => word.trim())
          //     .filter((word) => word !== "")
          //     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          //     .join(" ")
          //     .trimStart()
          //     .trimEnd(),
          //   lastName: values.lastName
          //     .toLowerCase()
          //     .split(" ")
          //     .map((word) => word.trim())
          //     .filter((word) => word !== "")
          //     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          //     .join(" ")
          //     .trimStart()
          //     .trimEnd(),
          //   companyName: values.companyName,
          //   mobileNo: values.mobileNo,
          //   userName: values.userName
          //     .toLowerCase()
          //     .split(" ")
          //     .map((word) => word.trim())
          //     .filter((word) => word !== "")
          //     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          //     .join(" ")
          //     .trimStart()
          //     .trimEnd(),
          //   password: values.password,
          //   address: values.address,
          //   email: values.email.toLowerCase(),
          //   pincode: values.pincode,
          //   country: country,
          //   state: state,
          //   district:district,
          //   // country: Country.getCountryByCode(country)?.name || "",
          //   // state: State.getStateByCodeAndCountry(state, country)?.name || "",
          //   city: values.city,
          //   jobCategory: values.jobCategory,
          //   deparment: values.deparment,
          //   role: values.designation,
          //   description: values.desc,
          //   createdBy: `${loginUserName}`,
          //   userProfile: base64Image,
          // };

          const data = {
            firstName: values.firstName.trim(),

            lastName: values.lastName.trim(),

            companyName: values.companyName,

            mobileNo: values.mobileNo,

            userName: values.userName.trim(),

            password: values.password,

            address: values.address,

            email: values.email.toLowerCase(),

            pincode: values.pincode,

            country: country,

            state: state,

            district: district,

            city: values.city,

            jobCategory: values.jobCategory,

            deparment: values.deparment,

            role: values.designation,

            description: values.desc,

            createdBy: `${loginUserName}`,

            userProfile: base64Image,
          };

          console.log("User Data", data);
          setTimeout(async () => {
            await postUserEntry(data)
              .then((result) => {
                setisLoaded(false);
                console.log("User Result", result);
                if (result.data.message === "mobile no already exist") {
                  swal("Failed", "Register Mobile No already exist", "warning");
                } else if (result.data.message === "email-id already exits") {
                  swal("Failed", "Email already exists", "warning");
                } else if (result.data.message === "username already exist") {
                  swal("Failed", "Username already exists", "warning");
                } else if (result.data.message === "user created successfully" && result.data.status === 200) {
                  swal("Great", "User created successfully...", "success");
                  resetForm();
                } else {
                  swal("Failed", "Failed to create user", "error");
                }
              })
              .catch((error) => {
                // ----- code to run if there are any problems
                console.log("User Error", error);
                setisLoaded(false);
                if (error.response.status === 400) {
                  console.log("error.response.data :-", error.response.data);
                  let userVal = error?.response?.data;
                  if (userVal?.firstName !== undefined) {
                    swal("Failed", "Please Enter First Name", "warning");
                    return false;
                  }
                  if (userVal?.lastName !== undefined) {
                    swal("Failed", "Please Enter Last Name", "warning");
                    return false;
                  }
                  if (userVal?.companyName !== undefined) {
                    swal("Failed", "Please Enter Company Name", "warning");
                    return false;
                  }
                  if (userVal?.mobileNo !== undefined) {
                    swal("Failed", "Please Enter Mobile Number", "warning");
                    return false;
                  }
                  if (userVal?.userName !== undefined) {
                    swal("Failed", "Please Enter User Name", "warning");
                    return false;
                  }
                  if (userVal?.password !== undefined) {
                    swal("Failed", "Please Enter Password", "warning");
                    return false;
                  }
                  if (userVal?.email !== undefined) {
                    swal("Failed", "Please Enter Email", "warning");
                    return false;
                  }
                  if (userVal?.address !== undefined) {
                    swal("Failed", "Please Enter Address", "warning");
                    return false;
                  }
                  if (userVal?.country !== undefined) {
                    swal("Failed", "Please Select Country", "warning");
                    return false;
                  }
                  if (userVal?.state !== undefined) {
                    swal("Failed", "Please Select State", "warning");
                    return false;
                  }
                  if (userVal?.city !== undefined) {
                    swal("Failed", "Please Enter City", "warning");
                    return false;
                  }
                  if (userVal?.description !== undefined) {
                    swal("Failed", "Please Enter Description", "warning");
                    return false;
                  }
                } else {
                  swal(
                    "Failed",
                    "Something went wrong please check your internet",
                    "error"
                  );
                }
              });
          }, 200);
        } catch (error) {
          console.log(error);
          setisLoaded(false);
          swal(
            "Failed",
            "Something went wrong please check your internet",
            "error"
          );
        }
      }}
    >
      {(formik) => {
        // ----- Formik provides the Form, Field and ErrorMessage
        const { isValid, dirty, isSubmitting } = formik;
        const isbuttondisable =
          formik.values.pincode &&
          formik.values.city &&
          base64Image;

        return (
          <>
            {isLoaded ? (
              <div className="reportload"></div>
            ) : (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                  <div className="d-flex">
                    <Link
                      to="user-entry-report"
                      className="fieldLink btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
                      Reports
                      <span className="icon icon-small ms-1"></span>
                    </Link>
                  </div>
                </div>
                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                    <h5 className="head mb-4">New User Entry Form</h5>
                    {/* ----- react-final-form ----- */}
                    <Form>
                      <Row>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              First Name *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Your First Name (Only alphabets allowed)"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="firstName"
                                  placeholder="Enter First Name"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="firstName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Last Name *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Your Last Name (Only alphabets allowed)"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="lastName"
                                  placeholder="Enter Last Name"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="lastName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Company Name *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Company Name"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="companyName"
                                  placeholder="Enter Company Name"
                                  autoComplete="off"
                                  validate={validateCompanyName}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="companyName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Mobile No. *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Mobile No"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="mobileNo"
                                  placeholder="Enter Mobile No."
                                  maxLength="10"
                                  autoComplete="off"
                                  validate={validateMobileNo}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="mobileNo"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Username *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Username"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="userName"
                                  placeholder="Enter Username"
                                  autoComplete="off"
                                  validate={validateUserName}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="userName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Password *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter 8 digit password"
                                direction="bottom"
                              >
                                <Field
                                  type={eyePass ? "text" : "password"}
                                  className="form-control"
                                  name="password"
                                  autoComplete="off"
                                  placeholder="Enter Password"
                                />
                              </ToolTip>
                            </div>
                            <span className="p-eye1" onClick={eyeTogglePass}>
                              <FontAwesomeIcon
                                icon={eyePass ? faEyeSlash : faEye}
                              />
                            </span>
                            <ErrorMessage
                              name="password"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Email *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="e.g. test@gmail.com or test@petrotec.com "
                                direction="bottom"
                              >
                                <Field
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  placeholder="Enter Email"
                                  autoComplete="off"
                                  validate={validateEmail}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage name="email" component={TextError} />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Pincode *</label>
                            <Field
                              type="text"
                              className="form-control"
                              name="pincode"
                              autoComplete="off"
                              maxLength="6"
                              placeholder="Enter Pincode"
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) e.preventDefault();
                              }}
                              onChange={(e) => {
                                formik.handleChange(e);
                                setPincode(e.target.value);
                                fetchAddressByPincode(e.target.value, formik);
                              }}

                            />
                            <ErrorMessage name="pincode" component={TextError} />
                          </div>
                        </Col>


                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Country </label>
                            <div className="example-wrapper">


                              <input
                                className="form-control"
                                value={country}
                                readOnly
                              />


                            </div>
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">State </label>
                            <div className="example-wrapper">


                              <input
                                className="form-control"
                                value={state}
                                readOnly
                              />


                            </div>
                          </div>
                        </Col>





                      </Row>
                      <Row>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">District </label>
                            <div className="example-wrapper">


                              <input
                                className="form-control"
                                value={district}
                                readOnly
                              />


                            </div>
                          </div>
                        </Col>


                        <Col md={6} className="mb-3">
                          <label className="LabelNew mb-1">City *</label>
                          <Select
                            placeholder={loadingPin ? "Loading..." : "Select City"}
                            options={cityOptions}
                            isDisabled={!cityOptions.length}
                            value={cityOptions.find(c => c.value === formik.values.city) || null}
                            onChange={(e) => formik.setFieldValue("city", e.value)}
                          />
                          <ErrorMessage name="city" component={TextError} />
                        </Col>


                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Address *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Address"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="2"
                                  className="form-control"
                                  name="address"
                                  maxLength={100}
                                  placeholder="Enter Address"
                                  autoComplete="off"
                                  title="Enter Address"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="address"
                              component={TextError}
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              User Category *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select User Category "
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select User Category"
                                  options={userDesignationList}
                                  onChange={(e) => {
                                    changeHandler(e);
                                    formik.setFieldValue(
                                      "designation",
                                      e.value
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="designation"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        {showJob ? (
                          <>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  Job Category
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Select Job Category"
                                    direction="bottom"
                                  >
                                    <Select
                                      placeholder="Select Job Category"
                                      options={jobList}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "jobCategory",
                                          e.value
                                        );
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="jobCategory"
                                  component={TextError}
                                />
                              </div>
                            </Col>
                          </>
                        ) : null}

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Deparment
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Job Category"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Job Category"
                                  options={departmentList}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "deparment",
                                      e.value
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="deparment"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mt-2">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Upload User Profile Photo *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Upload User Profile Photo"
                                direction="bottom"
                              >
                                <input
                                  type="file"
                                  className="form-control"
                                  name="uploadDispenserPhoto"
                                  placeholder="Upload User Profile Photo"
                                  accept=".jpg, .jpeg, .png"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "uploadDispenserPhoto",
                                      e.currentTarget.files[0]
                                    );
                                    SetuserProfile('')
                                    uploadImg(e);
                                  }}
                                />
                              </ToolTip>
                            </div>
                            {/* <ErrorMessage
                              name="uploadDispenserPhoto"
                              component={TextError}
                            /> */}
                            {userProfile && <p className="text-danger">{userProfile}</p>}
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Description *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Description"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="3"
                                  className="form-control"
                                  maxLength={100}
                                  name="desc"
                                  placeholder="Enter Description"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                          </div>
                          <ErrorMessage name="desc" component={TextError} />
                        </Col>


                      </Row>
                      <div className="mt-3">
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || !isbuttondisable}
                        >
                          Create User
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        );
      }}
    </Formik>
  );
};







